import { graphql } from '@/generated/gql';

export const DEMAND_RECOMMENDATION_QUERY = graphql(/* GraphQL */ `
  query DemandRecommendationQuery($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        status
        demandRequest {
          id
          lineItems {
            id
            position
            title
            description
            recommendations {
              id
              decisionStatus
              variant
              demandRequestItemId
              recommendedItem
            }
          }
        }
        permissions {
          write
        }
      }
    }
  }
`);
